import React from 'react';

type BadgeVariant = 'success' | 'danger' | 'warning' | 'info' | 'default';

type BadgeProps = React.ComponentPropsWithoutRef<'span'> & {
  variant?: BadgeVariant;
};

const variants = {
  success: 'bg-green-100 text-green-800',
  danger: 'bg-red-100 text-red-800',
  warning: 'bg-yellow-100 text-yellow-800',
  info: 'bg-blue-100 text-blue-800',
  default: 'bg-gray-100 text-gray-800',
};

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  className,
  ...props
}) => {
  return (
    <span
      className={`px-2.5 py-0.5 inline-flex text-xs font-medium rounded-full ${variants[variant]} ${className ?? ''}`}
      {...props}
    >
      {children}
    </span>
  );
};
